<template>
  <div class="box">
    <img class="tp" src="../assets/images/logo.jpg" alt="">
    <div class="loginbox">
      <!--<div class="login">-->
        <!--<img src="../assets/images/com.png" alt="">-->
        <!--<input v-model="logindata.enterprise" disabled="true" type="text" placeholder="輸入企業名稱">-->
      <!--</div>-->
      <!--<div class="address">-->
        <!--<p>+ {{$store.state.phoneCode}}</p>-->
        <!--<router-link class="minbut" tag="span" to="/selectareacode">切换地区</router-link>-->
      <!--</div>-->
      <div class="login">
        <img src="../assets/images/phone.png" alt="">
        <input v-model="logindata.username" v-on:keyup.enter="submission" type="text" placeholder="Email">
      </div>
      <div class="login">
        <img src="../assets/images/password.png" alt="">
        <input v-model="logindata.password" v-on:keyup.enter="submission" type="password" placeholder="Password">
      </div>
      <!--<div class="login verifybox">-->
        <!--<input v-model="logindata.verify" @keyup.enter="submission" type="text" placeholder="驗證碼">-->
        <!--<img @click="newVerify" :src="verifyurl" alt="">-->
      <!--</div>-->
    </div>
    <div class="butbox">
      <div @click="submission" class="but">logon</div>
      <div class="other">
        <router-link tag="span" to="/sellerforgetpassword">Forget Password</router-link>
        <router-link tag="span" to="/sellerregister">Register</router-link>
      </div>
    </div>
    <!--<router-link class="longo2" tag="div" to="/">普通用户登录</router-link>-->
  </div>
</template>

<script>
    import Input from '../assembly/Input/Input'
    import { MessageBox } from 'mint-ui';
    import {getCode,ecstloginForm,Api2_ecstloginForm,url} from '../assets/js/api'
    export default {
        name: "sellerlogin",
        components:{
          Input,
          MessageBox
        },
        data(){
          return {
            logindata:{
              enterprise:'Tesco',
              username:'',
              password:'',
              verify:'',
            },
            verifyurl:url+'/index.php/Home/Users/verify'
          }
        },
        mounted(){
          if (this.$store.state.phoneCode === ''){
            getCode().then((data)=>{
              // this.$store.commit('set_phoneCode',data.map(itme=>itme.region_num)[0])
              this.$store.commit('set_phoneCode',data[0].region_num)
            })
          }
          if (localStorage.getItem('logindata') && localStorage.getItem('userdata')){
            this.$router.push({ path: '/index'});
          }
          // ecstverify().then(data=>{
          //   console.log(data)
          // })
        },
        methods:{
          submission(){
            let state = true
            let message = ''
            if (this.logindata.enterprise === ''){
              message='請填寫企業名稱'
              state = false
            }
            else if (this.logindata.username === ''){
              message='請填寫用戶名稱'
              state = false
            }
            else if (this.logindata.password === ''){
              message='請填寫密碼'
              state = false
            }
            if (state) {
              Api2_ecstloginForm(this.logindata).then(data=>{
                if (data.status) {
                  this.Loginsuccessfully(data)
                }
                else {
                  if (this.$store.state.client){
                    MessageBox({
                      title: '提示',
                      showCancelButton: false,
                      message: data.message || data.data,
                      confirmButtonText:"确定",
                      closeOnClickModal:false,
                    }).then(res=>{
                      if (data.status) {
                        this.Loginsuccessfully(data)
                      }
                    })
                  }
                  else {
                    this.$alert(data.message || data.data, '提示', {
                      confirmButtonText: '确定',
                      callback: action => {
                        if (data.status) {
                          this.Loginsuccessfully(data)
                        }
                      }
                    });
                  }
                }
              })
            }
            else if (!localStorage.getItem('logindata')) {
              if (this.$store.state.client){
                MessageBox({
                  title: '提示',
                  showCancelButton: false,
                  message: message,
                  confirmButtonText:"确定",
                })
              }
              else {
                this.$alert(message, '提示', {
                  confirmButtonText: '确定',
                  callback: action => {
                    console.log(action)
                  }
                });
              }
            }
          },
          newVerify(e){
            e.target.src = this.verifyurl
          },
          Loginsuccessfully(data){
            localStorage.setItem('logindata',JSON.stringify(data.usersId))
            localStorage.setItem('userdata',JSON.stringify({
              username:this.logindata.username,
              // enterprise:this.logindata.enterprise,
              enterprise:'INCOME TEAM',
              socketCode:data.socketCode,
              supplier_company_id:data.supplier_company_id,
              supplier_company_name:data.supplier_company_name,
              users_role:Number(data.users_role),
              change_customer_name:data.change_customer_name, //更改醫生名稱的權限
            }))
            this.$store.commit('set_list_class',Number(data.users_role)) //用户角色
            this.$store.commit('set_loginuserdata',{
              username:this.logindata.username,
              // enterprise:this.logindata.enterprise //顯示的公司名稱INCOME TEAM Dental Laboratory
              enterprise:'INCOME TEAM'//顯示的公司名稱INCOME TEAM Dental Laboratory
            })

            if (this.$store.state.list_class === 0){
              this.$store.commit('set_Order_list_fields',this.$store.state.page_state.order_custom_yg)
            }
            else if (this.$store.state.list_class === 1){
              this.$store.commit('set_Order_list_fields',this.$store.state.page_state.order_custom)
            }
            else if (this.$store.state.list_class === 2){
              this.$store.commit('set_Order_list_fields',this.$store.state.page_state.order_custom_gys)
            }

            this.$router.push({ path: '/orderlist'});
          }
        }
    }
</script>

<style scoped lang="less">
  @import "../assets/less/base";
.box{
  text-align: center;
  margin-top: 50px;
  .tp{
    width: 100%;
  }
  @media (min-width: @screen-xs-max) {
    >img{
      max-height: 200px;
      width: auto !important;
      margin: 0 auto;
    }
  }
  .loginbox{
    width: 90%;
    margin: 20px auto;
    @media (min-width: @screen-xs-max) {
      width: 30%;
    }
    .address{
      display: flex;
      align-items: center;
      height: 26px;
      padding-bottom: 10px;
      border-bottom: 1px solid #e8e8e8;
      position: relative;
      margin: 20px 0;
      p{
        font-size: 0.3rem;
        width: 100%;
        padding-left: 0;
      }
      .minbut{
        display: block;
        padding: 5px 10px;
        position: absolute;
        border: 1px solid #979797;
        border-radius: 23px;
        right: 0;
        top: 0;
      }
    }
    .login{
      display: flex;
      justify-content: space-around;
      margin: 40px auto;
      position: relative;
      img{
        /*padding-bottom: 10px;*/
        width: 26px;
        height: 32px;
      }
      input{
        border: none;
        font-size: 0.3rem;
        border-bottom: 1px solid #979797;
        width: 80%;
        /*margin-left: 10%;*/
        &:focus{
          border-color: #22bb61;
        }
        &::placeholder{
          color: #7c7c7c;
        }
      }
    }
    .verifybox{
      width: 90%;
      img{
        width: auto;
        height: auto;
        margin-left: 5%;
        cursor: pointer;
      }
    }
  }
  .butbox{
    width: 80%;
    margin: 0 auto 20px auto;
    @media (min-width: @screen-xs-max) {
      width: 30%;
    }
    .but{
      text-align: center;
      padding: 16px 0;
      background-color: #979797;
      color: #353535;
      border-radius: 5px;
      margin-bottom: 20px;
      cursor: pointer;
    }
    .other{
      display: flex;
      justify-content: space-between;
      span{
        cursor: pointer;
      }
    }
  }
  .longo2{
    width: 30%;
    margin: 20px auto;
    text-align: center;
    padding: 16px 0;
    background-color: #979797;
    color: #353535;
    border-radius: 5px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/sellerlogin.vue